// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.5
//   protoc               v7.34.1
// source: integrations.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import { Struct } from "./google/protobuf/struct";
import { Timestamp } from "./google/protobuf/timestamp";

export const protobufPackage = "integrations";

export interface Integrations {
  paragonProvidersByName: { [key: string]: ParagonProvider };
  mcp: MCPConfiguration | undefined;
}

export interface Integrations_ParagonProvidersByNameEntry {
  key: string;
  value: ParagonProvider | undefined;
}

export interface MCPConfiguration {
  serversById: { [key: string]: MCPServer };
  profiles: { [key: string]: MCPProfile };
}

export interface MCPConfiguration_ServersByIdEntry {
  key: string;
  value: MCPServer | undefined;
}

export interface MCPConfiguration_ProfilesEntry {
  key: string;
  value: MCPProfile | undefined;
}

export interface MCPServer {
  id: string;
  providerId: string;
  url: string;
  auth: MCPAuth | undefined;
  timeout?: number | undefined;
  enabledFunctions: MCPEnabledFunctions | undefined;
  lastDiscoveredAt?: string | undefined;
  lastDiscoveredToolCount?: number | undefined;
}

export interface MCPProfile {
  providerId: string;
  url: string;
  auth: MCPAuth | undefined;
  timeout?: number | undefined;
}

export interface MCPAuth {
  header: string;
  queryParam: string;
  oauth: MCPOAuth | undefined;
  secretName: string;
}

export interface MCPOAuth {
  clientId: string;
  clientSecretName: string;
  tokenUrl: string;
  audience: string;
  scope: string;
}

export interface MCPEnabledFunctions {
  names: string[];
}

export interface ParagonProvider {
  providerId: string;
  availableFunctions: string[];
  timeout: number;
  envIntegrations: EnvironmentIntegrationRefs | undefined;
  integrationsById: { [key: string]: ParagonIntegration };
}

export interface ParagonProvider_IntegrationsByIdEntry {
  key: string;
  value: ParagonIntegration | undefined;
}

export interface EnvironmentIntegrationRefs {
  sandbox: string;
  preRelease: string;
  live: string;
}

export interface ParagonIntegration {
  paragonConnectionId: string;
  paragonUserId: string;
  metadata: { [key: string]: any } | undefined;
  createdAt: Date | undefined;
  createdBy: string;
  updatedAt: Date | undefined;
  updatedBy: string;
}

export interface IntegrationConnect {
  provider: string;
  paragonConnectionId: string;
  paragonUserId: string;
  clientEnv: string;
  metadata: { [key: string]: any } | undefined;
}

export interface IntegrationEnable {
  provider: string;
  paragonConnectionId: string;
  clientEnv: string;
}

export interface IntegrationDisable {
  provider: string;
  paragonConnectionId: string;
  clientEnv: string;
}

export interface IntegrationUpdateFunctions {
  provider: string;
  availableFunctions: string[];
}

export interface IntegrationDisconnect {
  provider: string;
  paragonConnectionId: string;
}

export interface MCPConfigUpdate {
  config: MCPConfiguration | undefined;
}

export interface MCPServerUpsert {
  server: MCPServer | undefined;
}

export interface MCPServerDelete {
  id: string;
}

export interface MCPProfileUpsert {
  profile: MCPProfile | undefined;
}

export interface MCPProfileDelete {
  providerId: string;
}

function createBaseIntegrations(): Integrations {
  return { paragonProvidersByName: {}, mcp: undefined };
}

export const Integrations: MessageFns<Integrations> = {
  encode(message: Integrations, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.paragonProvidersByName).forEach(([key, value]: [string, ParagonProvider]) => {
      Integrations_ParagonProvidersByNameEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    if (message.mcp !== undefined) {
      MCPConfiguration.encode(message.mcp, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Integrations {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIntegrations();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = Integrations_ParagonProvidersByNameEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.paragonProvidersByName[entry1.key] = entry1.value;
          }
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.mcp = MCPConfiguration.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Integrations {
    return {
      paragonProvidersByName: isObject(object.paragonProvidersByName)
        ? (globalThis.Object.entries(object.paragonProvidersByName) as [string, any][]).reduce(
          (acc: { [key: string]: ParagonProvider }, [key, value]: [string, any]) => {
            acc[key] = ParagonProvider.fromJSON(value);
            return acc;
          },
          {},
        )
        : isObject(object.paragon_providers_by_name)
        ? (globalThis.Object.entries(object.paragon_providers_by_name) as [string, any][]).reduce(
          (acc: { [key: string]: ParagonProvider }, [key, value]: [string, any]) => {
            acc[key] = ParagonProvider.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
      mcp: isSet(object.mcp) ? MCPConfiguration.fromJSON(object.mcp) : undefined,
    };
  },

  toJSON(message: Integrations): unknown {
    const obj: any = {};
    if (message.paragonProvidersByName) {
      const entries = globalThis.Object.entries(message.paragonProvidersByName) as [string, ParagonProvider][];
      if (entries.length > 0) {
        obj.paragonProvidersByName = {};
        entries.forEach(([k, v]) => {
          obj.paragonProvidersByName[k] = ParagonProvider.toJSON(v);
        });
      }
    }
    if (message.mcp !== undefined) {
      obj.mcp = MCPConfiguration.toJSON(message.mcp);
    }
    return obj;
  },

  create(base?: DeepPartial<Integrations>): Integrations {
    return Integrations.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Integrations>): Integrations {
    const message = createBaseIntegrations();
    message.paragonProvidersByName =
      (globalThis.Object.entries(object.paragonProvidersByName ?? {}) as [string, ParagonProvider][]).reduce(
        (acc: { [key: string]: ParagonProvider }, [key, value]: [string, ParagonProvider]) => {
          if (value !== undefined) {
            acc[key] = ParagonProvider.fromPartial(value);
          }
          return acc;
        },
        {},
      );
    message.mcp = (object.mcp !== undefined && object.mcp !== null)
      ? MCPConfiguration.fromPartial(object.mcp)
      : undefined;
    return message;
  },
};

function createBaseIntegrations_ParagonProvidersByNameEntry(): Integrations_ParagonProvidersByNameEntry {
  return { key: "", value: undefined };
}

export const Integrations_ParagonProvidersByNameEntry: MessageFns<Integrations_ParagonProvidersByNameEntry> = {
  encode(message: Integrations_ParagonProvidersByNameEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      ParagonProvider.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Integrations_ParagonProvidersByNameEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIntegrations_ParagonProvidersByNameEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = ParagonProvider.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Integrations_ParagonProvidersByNameEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? ParagonProvider.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: Integrations_ParagonProvidersByNameEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = ParagonProvider.toJSON(message.value);
    }
    return obj;
  },

  create(base?: DeepPartial<Integrations_ParagonProvidersByNameEntry>): Integrations_ParagonProvidersByNameEntry {
    return Integrations_ParagonProvidersByNameEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Integrations_ParagonProvidersByNameEntry>): Integrations_ParagonProvidersByNameEntry {
    const message = createBaseIntegrations_ParagonProvidersByNameEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? ParagonProvider.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseMCPConfiguration(): MCPConfiguration {
  return { serversById: {}, profiles: {} };
}

export const MCPConfiguration: MessageFns<MCPConfiguration> = {
  encode(message: MCPConfiguration, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.serversById).forEach(([key, value]: [string, MCPServer]) => {
      MCPConfiguration_ServersByIdEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    globalThis.Object.entries(message.profiles).forEach(([key, value]: [string, MCPProfile]) => {
      MCPConfiguration_ProfilesEntry.encode({ key: key as any, value }, writer.uint32(18).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MCPConfiguration {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMCPConfiguration();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = MCPConfiguration_ServersByIdEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.serversById[entry1.key] = entry1.value;
          }
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          const entry2 = MCPConfiguration_ProfilesEntry.decode(reader, reader.uint32());
          if (entry2.value !== undefined) {
            message.profiles[entry2.key] = entry2.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MCPConfiguration {
    return {
      serversById: isObject(object.serversById)
        ? (globalThis.Object.entries(object.serversById) as [string, any][]).reduce(
          (acc: { [key: string]: MCPServer }, [key, value]: [string, any]) => {
            acc[key] = MCPServer.fromJSON(value);
            return acc;
          },
          {},
        )
        : isObject(object.servers_by_id)
        ? (globalThis.Object.entries(object.servers_by_id) as [string, any][]).reduce(
          (acc: { [key: string]: MCPServer }, [key, value]: [string, any]) => {
            acc[key] = MCPServer.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
      profiles: isObject(object.profiles)
        ? (globalThis.Object.entries(object.profiles) as [string, any][]).reduce(
          (acc: { [key: string]: MCPProfile }, [key, value]: [string, any]) => {
            acc[key] = MCPProfile.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: MCPConfiguration): unknown {
    const obj: any = {};
    if (message.serversById) {
      const entries = globalThis.Object.entries(message.serversById) as [string, MCPServer][];
      if (entries.length > 0) {
        obj.serversById = {};
        entries.forEach(([k, v]) => {
          obj.serversById[k] = MCPServer.toJSON(v);
        });
      }
    }
    if (message.profiles) {
      const entries = globalThis.Object.entries(message.profiles) as [string, MCPProfile][];
      if (entries.length > 0) {
        obj.profiles = {};
        entries.forEach(([k, v]) => {
          obj.profiles[k] = MCPProfile.toJSON(v);
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<MCPConfiguration>): MCPConfiguration {
    return MCPConfiguration.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MCPConfiguration>): MCPConfiguration {
    const message = createBaseMCPConfiguration();
    message.serversById = (globalThis.Object.entries(object.serversById ?? {}) as [string, MCPServer][]).reduce(
      (acc: { [key: string]: MCPServer }, [key, value]: [string, MCPServer]) => {
        if (value !== undefined) {
          acc[key] = MCPServer.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    message.profiles = (globalThis.Object.entries(object.profiles ?? {}) as [string, MCPProfile][]).reduce(
      (acc: { [key: string]: MCPProfile }, [key, value]: [string, MCPProfile]) => {
        if (value !== undefined) {
          acc[key] = MCPProfile.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseMCPConfiguration_ServersByIdEntry(): MCPConfiguration_ServersByIdEntry {
  return { key: "", value: undefined };
}

export const MCPConfiguration_ServersByIdEntry: MessageFns<MCPConfiguration_ServersByIdEntry> = {
  encode(message: MCPConfiguration_ServersByIdEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      MCPServer.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MCPConfiguration_ServersByIdEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMCPConfiguration_ServersByIdEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = MCPServer.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MCPConfiguration_ServersByIdEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? MCPServer.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: MCPConfiguration_ServersByIdEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = MCPServer.toJSON(message.value);
    }
    return obj;
  },

  create(base?: DeepPartial<MCPConfiguration_ServersByIdEntry>): MCPConfiguration_ServersByIdEntry {
    return MCPConfiguration_ServersByIdEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MCPConfiguration_ServersByIdEntry>): MCPConfiguration_ServersByIdEntry {
    const message = createBaseMCPConfiguration_ServersByIdEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? MCPServer.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseMCPConfiguration_ProfilesEntry(): MCPConfiguration_ProfilesEntry {
  return { key: "", value: undefined };
}

export const MCPConfiguration_ProfilesEntry: MessageFns<MCPConfiguration_ProfilesEntry> = {
  encode(message: MCPConfiguration_ProfilesEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      MCPProfile.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MCPConfiguration_ProfilesEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMCPConfiguration_ProfilesEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = MCPProfile.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MCPConfiguration_ProfilesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? MCPProfile.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: MCPConfiguration_ProfilesEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = MCPProfile.toJSON(message.value);
    }
    return obj;
  },

  create(base?: DeepPartial<MCPConfiguration_ProfilesEntry>): MCPConfiguration_ProfilesEntry {
    return MCPConfiguration_ProfilesEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MCPConfiguration_ProfilesEntry>): MCPConfiguration_ProfilesEntry {
    const message = createBaseMCPConfiguration_ProfilesEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? MCPProfile.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseMCPServer(): MCPServer {
  return {
    id: "",
    providerId: "",
    url: "",
    auth: undefined,
    timeout: undefined,
    enabledFunctions: undefined,
    lastDiscoveredAt: undefined,
    lastDiscoveredToolCount: undefined,
  };
}

export const MCPServer: MessageFns<MCPServer> = {
  encode(message: MCPServer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.providerId !== "") {
      writer.uint32(18).string(message.providerId);
    }
    if (message.url !== "") {
      writer.uint32(26).string(message.url);
    }
    if (message.auth !== undefined) {
      MCPAuth.encode(message.auth, writer.uint32(34).fork()).join();
    }
    if (message.timeout !== undefined) {
      writer.uint32(40).uint32(message.timeout);
    }
    if (message.enabledFunctions !== undefined) {
      MCPEnabledFunctions.encode(message.enabledFunctions, writer.uint32(50).fork()).join();
    }
    if (message.lastDiscoveredAt !== undefined) {
      writer.uint32(58).string(message.lastDiscoveredAt);
    }
    if (message.lastDiscoveredToolCount !== undefined) {
      writer.uint32(64).uint32(message.lastDiscoveredToolCount);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MCPServer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMCPServer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.providerId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.url = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.auth = MCPAuth.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.timeout = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.enabledFunctions = MCPEnabledFunctions.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.lastDiscoveredAt = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.lastDiscoveredToolCount = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MCPServer {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      providerId: isSet(object.providerId)
        ? globalThis.String(object.providerId)
        : isSet(object.provider_id)
        ? globalThis.String(object.provider_id)
        : "",
      url: isSet(object.url) ? globalThis.String(object.url) : "",
      auth: isSet(object.auth) ? MCPAuth.fromJSON(object.auth) : undefined,
      timeout: isSet(object.timeout) ? globalThis.Number(object.timeout) : undefined,
      enabledFunctions: isSet(object.enabledFunctions)
        ? MCPEnabledFunctions.fromJSON(object.enabledFunctions)
        : isSet(object.enabled_functions)
        ? MCPEnabledFunctions.fromJSON(object.enabled_functions)
        : undefined,
      lastDiscoveredAt: isSet(object.lastDiscoveredAt)
        ? globalThis.String(object.lastDiscoveredAt)
        : isSet(object.last_discovered_at)
        ? globalThis.String(object.last_discovered_at)
        : undefined,
      lastDiscoveredToolCount: isSet(object.lastDiscoveredToolCount)
        ? globalThis.Number(object.lastDiscoveredToolCount)
        : isSet(object.last_discovered_tool_count)
        ? globalThis.Number(object.last_discovered_tool_count)
        : undefined,
    };
  },

  toJSON(message: MCPServer): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.providerId !== "") {
      obj.providerId = message.providerId;
    }
    if (message.url !== "") {
      obj.url = message.url;
    }
    if (message.auth !== undefined) {
      obj.auth = MCPAuth.toJSON(message.auth);
    }
    if (message.timeout !== undefined) {
      obj.timeout = Math.round(message.timeout);
    }
    if (message.enabledFunctions !== undefined) {
      obj.enabledFunctions = MCPEnabledFunctions.toJSON(message.enabledFunctions);
    }
    if (message.lastDiscoveredAt !== undefined) {
      obj.lastDiscoveredAt = message.lastDiscoveredAt;
    }
    if (message.lastDiscoveredToolCount !== undefined) {
      obj.lastDiscoveredToolCount = Math.round(message.lastDiscoveredToolCount);
    }
    return obj;
  },

  create(base?: DeepPartial<MCPServer>): MCPServer {
    return MCPServer.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MCPServer>): MCPServer {
    const message = createBaseMCPServer();
    message.id = object.id ?? "";
    message.providerId = object.providerId ?? "";
    message.url = object.url ?? "";
    message.auth = (object.auth !== undefined && object.auth !== null) ? MCPAuth.fromPartial(object.auth) : undefined;
    message.timeout = object.timeout ?? undefined;
    message.enabledFunctions = (object.enabledFunctions !== undefined && object.enabledFunctions !== null)
      ? MCPEnabledFunctions.fromPartial(object.enabledFunctions)
      : undefined;
    message.lastDiscoveredAt = object.lastDiscoveredAt ?? undefined;
    message.lastDiscoveredToolCount = object.lastDiscoveredToolCount ?? undefined;
    return message;
  },
};

function createBaseMCPProfile(): MCPProfile {
  return { providerId: "", url: "", auth: undefined, timeout: undefined };
}

export const MCPProfile: MessageFns<MCPProfile> = {
  encode(message: MCPProfile, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.providerId !== "") {
      writer.uint32(10).string(message.providerId);
    }
    if (message.url !== "") {
      writer.uint32(18).string(message.url);
    }
    if (message.auth !== undefined) {
      MCPAuth.encode(message.auth, writer.uint32(26).fork()).join();
    }
    if (message.timeout !== undefined) {
      writer.uint32(32).uint32(message.timeout);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MCPProfile {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMCPProfile();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.providerId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.url = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.auth = MCPAuth.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.timeout = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MCPProfile {
    return {
      providerId: isSet(object.providerId)
        ? globalThis.String(object.providerId)
        : isSet(object.provider_id)
        ? globalThis.String(object.provider_id)
        : "",
      url: isSet(object.url) ? globalThis.String(object.url) : "",
      auth: isSet(object.auth) ? MCPAuth.fromJSON(object.auth) : undefined,
      timeout: isSet(object.timeout) ? globalThis.Number(object.timeout) : undefined,
    };
  },

  toJSON(message: MCPProfile): unknown {
    const obj: any = {};
    if (message.providerId !== "") {
      obj.providerId = message.providerId;
    }
    if (message.url !== "") {
      obj.url = message.url;
    }
    if (message.auth !== undefined) {
      obj.auth = MCPAuth.toJSON(message.auth);
    }
    if (message.timeout !== undefined) {
      obj.timeout = Math.round(message.timeout);
    }
    return obj;
  },

  create(base?: DeepPartial<MCPProfile>): MCPProfile {
    return MCPProfile.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MCPProfile>): MCPProfile {
    const message = createBaseMCPProfile();
    message.providerId = object.providerId ?? "";
    message.url = object.url ?? "";
    message.auth = (object.auth !== undefined && object.auth !== null) ? MCPAuth.fromPartial(object.auth) : undefined;
    message.timeout = object.timeout ?? undefined;
    return message;
  },
};

function createBaseMCPAuth(): MCPAuth {
  return { header: "", queryParam: "", oauth: undefined, secretName: "" };
}

export const MCPAuth: MessageFns<MCPAuth> = {
  encode(message: MCPAuth, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== "") {
      writer.uint32(10).string(message.header);
    }
    if (message.queryParam !== "") {
      writer.uint32(18).string(message.queryParam);
    }
    if (message.oauth !== undefined) {
      MCPOAuth.encode(message.oauth, writer.uint32(26).fork()).join();
    }
    if (message.secretName !== "") {
      writer.uint32(34).string(message.secretName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MCPAuth {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMCPAuth();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.queryParam = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.oauth = MCPOAuth.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.secretName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MCPAuth {
    return {
      header: isSet(object.header) ? globalThis.String(object.header) : "",
      queryParam: isSet(object.queryParam)
        ? globalThis.String(object.queryParam)
        : isSet(object.query_param)
        ? globalThis.String(object.query_param)
        : "",
      oauth: isSet(object.oauth) ? MCPOAuth.fromJSON(object.oauth) : undefined,
      secretName: isSet(object.secretName)
        ? globalThis.String(object.secretName)
        : isSet(object.secret_name)
        ? globalThis.String(object.secret_name)
        : "",
    };
  },

  toJSON(message: MCPAuth): unknown {
    const obj: any = {};
    if (message.header !== "") {
      obj.header = message.header;
    }
    if (message.queryParam !== "") {
      obj.queryParam = message.queryParam;
    }
    if (message.oauth !== undefined) {
      obj.oauth = MCPOAuth.toJSON(message.oauth);
    }
    if (message.secretName !== "") {
      obj.secretName = message.secretName;
    }
    return obj;
  },

  create(base?: DeepPartial<MCPAuth>): MCPAuth {
    return MCPAuth.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MCPAuth>): MCPAuth {
    const message = createBaseMCPAuth();
    message.header = object.header ?? "";
    message.queryParam = object.queryParam ?? "";
    message.oauth = (object.oauth !== undefined && object.oauth !== null)
      ? MCPOAuth.fromPartial(object.oauth)
      : undefined;
    message.secretName = object.secretName ?? "";
    return message;
  },
};

function createBaseMCPOAuth(): MCPOAuth {
  return { clientId: "", clientSecretName: "", tokenUrl: "", audience: "", scope: "" };
}

export const MCPOAuth: MessageFns<MCPOAuth> = {
  encode(message: MCPOAuth, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.clientId !== "") {
      writer.uint32(10).string(message.clientId);
    }
    if (message.clientSecretName !== "") {
      writer.uint32(18).string(message.clientSecretName);
    }
    if (message.tokenUrl !== "") {
      writer.uint32(26).string(message.tokenUrl);
    }
    if (message.audience !== "") {
      writer.uint32(34).string(message.audience);
    }
    if (message.scope !== "") {
      writer.uint32(42).string(message.scope);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MCPOAuth {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMCPOAuth();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.clientId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.clientSecretName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.tokenUrl = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.audience = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.scope = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MCPOAuth {
    return {
      clientId: isSet(object.clientId)
        ? globalThis.String(object.clientId)
        : isSet(object.client_id)
        ? globalThis.String(object.client_id)
        : "",
      clientSecretName: isSet(object.clientSecretName)
        ? globalThis.String(object.clientSecretName)
        : isSet(object.client_secret_name)
        ? globalThis.String(object.client_secret_name)
        : "",
      tokenUrl: isSet(object.tokenUrl)
        ? globalThis.String(object.tokenUrl)
        : isSet(object.token_url)
        ? globalThis.String(object.token_url)
        : "",
      audience: isSet(object.audience) ? globalThis.String(object.audience) : "",
      scope: isSet(object.scope) ? globalThis.String(object.scope) : "",
    };
  },

  toJSON(message: MCPOAuth): unknown {
    const obj: any = {};
    if (message.clientId !== "") {
      obj.clientId = message.clientId;
    }
    if (message.clientSecretName !== "") {
      obj.clientSecretName = message.clientSecretName;
    }
    if (message.tokenUrl !== "") {
      obj.tokenUrl = message.tokenUrl;
    }
    if (message.audience !== "") {
      obj.audience = message.audience;
    }
    if (message.scope !== "") {
      obj.scope = message.scope;
    }
    return obj;
  },

  create(base?: DeepPartial<MCPOAuth>): MCPOAuth {
    return MCPOAuth.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MCPOAuth>): MCPOAuth {
    const message = createBaseMCPOAuth();
    message.clientId = object.clientId ?? "";
    message.clientSecretName = object.clientSecretName ?? "";
    message.tokenUrl = object.tokenUrl ?? "";
    message.audience = object.audience ?? "";
    message.scope = object.scope ?? "";
    return message;
  },
};

function createBaseMCPEnabledFunctions(): MCPEnabledFunctions {
  return { names: [] };
}

export const MCPEnabledFunctions: MessageFns<MCPEnabledFunctions> = {
  encode(message: MCPEnabledFunctions, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.names) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MCPEnabledFunctions {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMCPEnabledFunctions();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.names.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MCPEnabledFunctions {
    return { names: globalThis.Array.isArray(object?.names) ? object.names.map((e: any) => globalThis.String(e)) : [] };
  },

  toJSON(message: MCPEnabledFunctions): unknown {
    const obj: any = {};
    if (message.names?.length) {
      obj.names = message.names;
    }
    return obj;
  },

  create(base?: DeepPartial<MCPEnabledFunctions>): MCPEnabledFunctions {
    return MCPEnabledFunctions.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MCPEnabledFunctions>): MCPEnabledFunctions {
    const message = createBaseMCPEnabledFunctions();
    message.names = object.names?.map((e) => e) || [];
    return message;
  },
};

function createBaseParagonProvider(): ParagonProvider {
  return { providerId: "", availableFunctions: [], timeout: 0, envIntegrations: undefined, integrationsById: {} };
}

export const ParagonProvider: MessageFns<ParagonProvider> = {
  encode(message: ParagonProvider, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.providerId !== "") {
      writer.uint32(10).string(message.providerId);
    }
    for (const v of message.availableFunctions) {
      writer.uint32(18).string(v!);
    }
    if (message.timeout !== 0) {
      writer.uint32(24).uint32(message.timeout);
    }
    if (message.envIntegrations !== undefined) {
      EnvironmentIntegrationRefs.encode(message.envIntegrations, writer.uint32(34).fork()).join();
    }
    globalThis.Object.entries(message.integrationsById).forEach(([key, value]: [string, ParagonIntegration]) => {
      ParagonProvider_IntegrationsByIdEntry.encode({ key: key as any, value }, writer.uint32(42).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ParagonProvider {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParagonProvider();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.providerId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.availableFunctions.push(reader.string());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.timeout = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.envIntegrations = EnvironmentIntegrationRefs.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          const entry5 = ParagonProvider_IntegrationsByIdEntry.decode(reader, reader.uint32());
          if (entry5.value !== undefined) {
            message.integrationsById[entry5.key] = entry5.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ParagonProvider {
    return {
      providerId: isSet(object.providerId)
        ? globalThis.String(object.providerId)
        : isSet(object.provider_id)
        ? globalThis.String(object.provider_id)
        : "",
      availableFunctions: globalThis.Array.isArray(object?.availableFunctions)
        ? object.availableFunctions.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.available_functions)
        ? object.available_functions.map((e: any) => globalThis.String(e))
        : [],
      timeout: isSet(object.timeout) ? globalThis.Number(object.timeout) : 0,
      envIntegrations: isSet(object.envIntegrations)
        ? EnvironmentIntegrationRefs.fromJSON(object.envIntegrations)
        : isSet(object.env_integrations)
        ? EnvironmentIntegrationRefs.fromJSON(object.env_integrations)
        : undefined,
      integrationsById: isObject(object.integrationsById)
        ? (globalThis.Object.entries(object.integrationsById) as [string, any][]).reduce(
          (acc: { [key: string]: ParagonIntegration }, [key, value]: [string, any]) => {
            acc[key] = ParagonIntegration.fromJSON(value);
            return acc;
          },
          {},
        )
        : isObject(object.integrations_by_id)
        ? (globalThis.Object.entries(object.integrations_by_id) as [string, any][]).reduce(
          (acc: { [key: string]: ParagonIntegration }, [key, value]: [string, any]) => {
            acc[key] = ParagonIntegration.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: ParagonProvider): unknown {
    const obj: any = {};
    if (message.providerId !== "") {
      obj.providerId = message.providerId;
    }
    if (message.availableFunctions?.length) {
      obj.availableFunctions = message.availableFunctions;
    }
    if (message.timeout !== 0) {
      obj.timeout = Math.round(message.timeout);
    }
    if (message.envIntegrations !== undefined) {
      obj.envIntegrations = EnvironmentIntegrationRefs.toJSON(message.envIntegrations);
    }
    if (message.integrationsById) {
      const entries = globalThis.Object.entries(message.integrationsById) as [string, ParagonIntegration][];
      if (entries.length > 0) {
        obj.integrationsById = {};
        entries.forEach(([k, v]) => {
          obj.integrationsById[k] = ParagonIntegration.toJSON(v);
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<ParagonProvider>): ParagonProvider {
    return ParagonProvider.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ParagonProvider>): ParagonProvider {
    const message = createBaseParagonProvider();
    message.providerId = object.providerId ?? "";
    message.availableFunctions = object.availableFunctions?.map((e) => e) || [];
    message.timeout = object.timeout ?? 0;
    message.envIntegrations = (object.envIntegrations !== undefined && object.envIntegrations !== null)
      ? EnvironmentIntegrationRefs.fromPartial(object.envIntegrations)
      : undefined;
    message.integrationsById =
      (globalThis.Object.entries(object.integrationsById ?? {}) as [string, ParagonIntegration][]).reduce(
        (acc: { [key: string]: ParagonIntegration }, [key, value]: [string, ParagonIntegration]) => {
          if (value !== undefined) {
            acc[key] = ParagonIntegration.fromPartial(value);
          }
          return acc;
        },
        {},
      );
    return message;
  },
};

function createBaseParagonProvider_IntegrationsByIdEntry(): ParagonProvider_IntegrationsByIdEntry {
  return { key: "", value: undefined };
}

export const ParagonProvider_IntegrationsByIdEntry: MessageFns<ParagonProvider_IntegrationsByIdEntry> = {
  encode(message: ParagonProvider_IntegrationsByIdEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      ParagonIntegration.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ParagonProvider_IntegrationsByIdEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParagonProvider_IntegrationsByIdEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = ParagonIntegration.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ParagonProvider_IntegrationsByIdEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? ParagonIntegration.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: ParagonProvider_IntegrationsByIdEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = ParagonIntegration.toJSON(message.value);
    }
    return obj;
  },

  create(base?: DeepPartial<ParagonProvider_IntegrationsByIdEntry>): ParagonProvider_IntegrationsByIdEntry {
    return ParagonProvider_IntegrationsByIdEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ParagonProvider_IntegrationsByIdEntry>): ParagonProvider_IntegrationsByIdEntry {
    const message = createBaseParagonProvider_IntegrationsByIdEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? ParagonIntegration.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseEnvironmentIntegrationRefs(): EnvironmentIntegrationRefs {
  return { sandbox: "", preRelease: "", live: "" };
}

export const EnvironmentIntegrationRefs: MessageFns<EnvironmentIntegrationRefs> = {
  encode(message: EnvironmentIntegrationRefs, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sandbox !== "") {
      writer.uint32(10).string(message.sandbox);
    }
    if (message.preRelease !== "") {
      writer.uint32(18).string(message.preRelease);
    }
    if (message.live !== "") {
      writer.uint32(26).string(message.live);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EnvironmentIntegrationRefs {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEnvironmentIntegrationRefs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.sandbox = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.preRelease = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.live = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EnvironmentIntegrationRefs {
    return {
      sandbox: isSet(object.sandbox) ? globalThis.String(object.sandbox) : "",
      preRelease: isSet(object.preRelease)
        ? globalThis.String(object.preRelease)
        : isSet(object.pre_release)
        ? globalThis.String(object.pre_release)
        : "",
      live: isSet(object.live) ? globalThis.String(object.live) : "",
    };
  },

  toJSON(message: EnvironmentIntegrationRefs): unknown {
    const obj: any = {};
    if (message.sandbox !== "") {
      obj.sandbox = message.sandbox;
    }
    if (message.preRelease !== "") {
      obj.preRelease = message.preRelease;
    }
    if (message.live !== "") {
      obj.live = message.live;
    }
    return obj;
  },

  create(base?: DeepPartial<EnvironmentIntegrationRefs>): EnvironmentIntegrationRefs {
    return EnvironmentIntegrationRefs.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<EnvironmentIntegrationRefs>): EnvironmentIntegrationRefs {
    const message = createBaseEnvironmentIntegrationRefs();
    message.sandbox = object.sandbox ?? "";
    message.preRelease = object.preRelease ?? "";
    message.live = object.live ?? "";
    return message;
  },
};

function createBaseParagonIntegration(): ParagonIntegration {
  return {
    paragonConnectionId: "",
    paragonUserId: "",
    metadata: undefined,
    createdAt: undefined,
    createdBy: "",
    updatedAt: undefined,
    updatedBy: "",
  };
}

export const ParagonIntegration: MessageFns<ParagonIntegration> = {
  encode(message: ParagonIntegration, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.paragonConnectionId !== "") {
      writer.uint32(10).string(message.paragonConnectionId);
    }
    if (message.paragonUserId !== "") {
      writer.uint32(18).string(message.paragonUserId);
    }
    if (message.metadata !== undefined) {
      Struct.encode(Struct.wrap(message.metadata), writer.uint32(26).fork()).join();
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(34).fork()).join();
    }
    if (message.createdBy !== "") {
      writer.uint32(42).string(message.createdBy);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(50).fork()).join();
    }
    if (message.updatedBy !== "") {
      writer.uint32(58).string(message.updatedBy);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ParagonIntegration {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParagonIntegration();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.paragonConnectionId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.paragonUserId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.metadata = Struct.unwrap(Struct.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ParagonIntegration {
    return {
      paragonConnectionId: isSet(object.paragonConnectionId)
        ? globalThis.String(object.paragonConnectionId)
        : isSet(object.paragon_connection_id)
        ? globalThis.String(object.paragon_connection_id)
        : "",
      paragonUserId: isSet(object.paragonUserId)
        ? globalThis.String(object.paragonUserId)
        : isSet(object.paragon_user_id)
        ? globalThis.String(object.paragon_user_id)
        : "",
      metadata: isObject(object.metadata) ? object.metadata : undefined,
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : "",
    };
  },

  toJSON(message: ParagonIntegration): unknown {
    const obj: any = {};
    if (message.paragonConnectionId !== "") {
      obj.paragonConnectionId = message.paragonConnectionId;
    }
    if (message.paragonUserId !== "") {
      obj.paragonUserId = message.paragonUserId;
    }
    if (message.metadata !== undefined) {
      obj.metadata = message.metadata;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.updatedBy !== "") {
      obj.updatedBy = message.updatedBy;
    }
    return obj;
  },

  create(base?: DeepPartial<ParagonIntegration>): ParagonIntegration {
    return ParagonIntegration.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ParagonIntegration>): ParagonIntegration {
    const message = createBaseParagonIntegration();
    message.paragonConnectionId = object.paragonConnectionId ?? "";
    message.paragonUserId = object.paragonUserId ?? "";
    message.metadata = object.metadata ?? undefined;
    message.createdAt = object.createdAt ?? undefined;
    message.createdBy = object.createdBy ?? "";
    message.updatedAt = object.updatedAt ?? undefined;
    message.updatedBy = object.updatedBy ?? "";
    return message;
  },
};

function createBaseIntegrationConnect(): IntegrationConnect {
  return { provider: "", paragonConnectionId: "", paragonUserId: "", clientEnv: "", metadata: undefined };
}

export const IntegrationConnect: MessageFns<IntegrationConnect> = {
  encode(message: IntegrationConnect, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.provider !== "") {
      writer.uint32(10).string(message.provider);
    }
    if (message.paragonConnectionId !== "") {
      writer.uint32(18).string(message.paragonConnectionId);
    }
    if (message.paragonUserId !== "") {
      writer.uint32(26).string(message.paragonUserId);
    }
    if (message.clientEnv !== "") {
      writer.uint32(42).string(message.clientEnv);
    }
    if (message.metadata !== undefined) {
      Struct.encode(Struct.wrap(message.metadata), writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IntegrationConnect {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIntegrationConnect();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.provider = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.paragonConnectionId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.paragonUserId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.clientEnv = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.metadata = Struct.unwrap(Struct.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IntegrationConnect {
    return {
      provider: isSet(object.provider) ? globalThis.String(object.provider) : "",
      paragonConnectionId: isSet(object.paragonConnectionId)
        ? globalThis.String(object.paragonConnectionId)
        : isSet(object.paragon_connection_id)
        ? globalThis.String(object.paragon_connection_id)
        : "",
      paragonUserId: isSet(object.paragonUserId)
        ? globalThis.String(object.paragonUserId)
        : isSet(object.paragon_user_id)
        ? globalThis.String(object.paragon_user_id)
        : "",
      clientEnv: isSet(object.clientEnv)
        ? globalThis.String(object.clientEnv)
        : isSet(object.client_env)
        ? globalThis.String(object.client_env)
        : "",
      metadata: isObject(object.metadata) ? object.metadata : undefined,
    };
  },

  toJSON(message: IntegrationConnect): unknown {
    const obj: any = {};
    if (message.provider !== "") {
      obj.provider = message.provider;
    }
    if (message.paragonConnectionId !== "") {
      obj.paragonConnectionId = message.paragonConnectionId;
    }
    if (message.paragonUserId !== "") {
      obj.paragonUserId = message.paragonUserId;
    }
    if (message.clientEnv !== "") {
      obj.clientEnv = message.clientEnv;
    }
    if (message.metadata !== undefined) {
      obj.metadata = message.metadata;
    }
    return obj;
  },

  create(base?: DeepPartial<IntegrationConnect>): IntegrationConnect {
    return IntegrationConnect.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<IntegrationConnect>): IntegrationConnect {
    const message = createBaseIntegrationConnect();
    message.provider = object.provider ?? "";
    message.paragonConnectionId = object.paragonConnectionId ?? "";
    message.paragonUserId = object.paragonUserId ?? "";
    message.clientEnv = object.clientEnv ?? "";
    message.metadata = object.metadata ?? undefined;
    return message;
  },
};

function createBaseIntegrationEnable(): IntegrationEnable {
  return { provider: "", paragonConnectionId: "", clientEnv: "" };
}

export const IntegrationEnable: MessageFns<IntegrationEnable> = {
  encode(message: IntegrationEnable, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.provider !== "") {
      writer.uint32(10).string(message.provider);
    }
    if (message.paragonConnectionId !== "") {
      writer.uint32(18).string(message.paragonConnectionId);
    }
    if (message.clientEnv !== "") {
      writer.uint32(26).string(message.clientEnv);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IntegrationEnable {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIntegrationEnable();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.provider = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.paragonConnectionId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.clientEnv = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IntegrationEnable {
    return {
      provider: isSet(object.provider) ? globalThis.String(object.provider) : "",
      paragonConnectionId: isSet(object.paragonConnectionId)
        ? globalThis.String(object.paragonConnectionId)
        : isSet(object.paragon_connection_id)
        ? globalThis.String(object.paragon_connection_id)
        : "",
      clientEnv: isSet(object.clientEnv)
        ? globalThis.String(object.clientEnv)
        : isSet(object.client_env)
        ? globalThis.String(object.client_env)
        : "",
    };
  },

  toJSON(message: IntegrationEnable): unknown {
    const obj: any = {};
    if (message.provider !== "") {
      obj.provider = message.provider;
    }
    if (message.paragonConnectionId !== "") {
      obj.paragonConnectionId = message.paragonConnectionId;
    }
    if (message.clientEnv !== "") {
      obj.clientEnv = message.clientEnv;
    }
    return obj;
  },

  create(base?: DeepPartial<IntegrationEnable>): IntegrationEnable {
    return IntegrationEnable.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<IntegrationEnable>): IntegrationEnable {
    const message = createBaseIntegrationEnable();
    message.provider = object.provider ?? "";
    message.paragonConnectionId = object.paragonConnectionId ?? "";
    message.clientEnv = object.clientEnv ?? "";
    return message;
  },
};

function createBaseIntegrationDisable(): IntegrationDisable {
  return { provider: "", paragonConnectionId: "", clientEnv: "" };
}

export const IntegrationDisable: MessageFns<IntegrationDisable> = {
  encode(message: IntegrationDisable, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.provider !== "") {
      writer.uint32(10).string(message.provider);
    }
    if (message.paragonConnectionId !== "") {
      writer.uint32(18).string(message.paragonConnectionId);
    }
    if (message.clientEnv !== "") {
      writer.uint32(26).string(message.clientEnv);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IntegrationDisable {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIntegrationDisable();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.provider = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.paragonConnectionId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.clientEnv = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IntegrationDisable {
    return {
      provider: isSet(object.provider) ? globalThis.String(object.provider) : "",
      paragonConnectionId: isSet(object.paragonConnectionId)
        ? globalThis.String(object.paragonConnectionId)
        : isSet(object.paragon_connection_id)
        ? globalThis.String(object.paragon_connection_id)
        : "",
      clientEnv: isSet(object.clientEnv)
        ? globalThis.String(object.clientEnv)
        : isSet(object.client_env)
        ? globalThis.String(object.client_env)
        : "",
    };
  },

  toJSON(message: IntegrationDisable): unknown {
    const obj: any = {};
    if (message.provider !== "") {
      obj.provider = message.provider;
    }
    if (message.paragonConnectionId !== "") {
      obj.paragonConnectionId = message.paragonConnectionId;
    }
    if (message.clientEnv !== "") {
      obj.clientEnv = message.clientEnv;
    }
    return obj;
  },

  create(base?: DeepPartial<IntegrationDisable>): IntegrationDisable {
    return IntegrationDisable.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<IntegrationDisable>): IntegrationDisable {
    const message = createBaseIntegrationDisable();
    message.provider = object.provider ?? "";
    message.paragonConnectionId = object.paragonConnectionId ?? "";
    message.clientEnv = object.clientEnv ?? "";
    return message;
  },
};

function createBaseIntegrationUpdateFunctions(): IntegrationUpdateFunctions {
  return { provider: "", availableFunctions: [] };
}

export const IntegrationUpdateFunctions: MessageFns<IntegrationUpdateFunctions> = {
  encode(message: IntegrationUpdateFunctions, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.provider !== "") {
      writer.uint32(10).string(message.provider);
    }
    for (const v of message.availableFunctions) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IntegrationUpdateFunctions {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIntegrationUpdateFunctions();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.provider = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.availableFunctions.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IntegrationUpdateFunctions {
    return {
      provider: isSet(object.provider) ? globalThis.String(object.provider) : "",
      availableFunctions: globalThis.Array.isArray(object?.availableFunctions)
        ? object.availableFunctions.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.available_functions)
        ? object.available_functions.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: IntegrationUpdateFunctions): unknown {
    const obj: any = {};
    if (message.provider !== "") {
      obj.provider = message.provider;
    }
    if (message.availableFunctions?.length) {
      obj.availableFunctions = message.availableFunctions;
    }
    return obj;
  },

  create(base?: DeepPartial<IntegrationUpdateFunctions>): IntegrationUpdateFunctions {
    return IntegrationUpdateFunctions.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<IntegrationUpdateFunctions>): IntegrationUpdateFunctions {
    const message = createBaseIntegrationUpdateFunctions();
    message.provider = object.provider ?? "";
    message.availableFunctions = object.availableFunctions?.map((e) => e) || [];
    return message;
  },
};

function createBaseIntegrationDisconnect(): IntegrationDisconnect {
  return { provider: "", paragonConnectionId: "" };
}

export const IntegrationDisconnect: MessageFns<IntegrationDisconnect> = {
  encode(message: IntegrationDisconnect, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.provider !== "") {
      writer.uint32(10).string(message.provider);
    }
    if (message.paragonConnectionId !== "") {
      writer.uint32(18).string(message.paragonConnectionId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IntegrationDisconnect {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIntegrationDisconnect();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.provider = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.paragonConnectionId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IntegrationDisconnect {
    return {
      provider: isSet(object.provider) ? globalThis.String(object.provider) : "",
      paragonConnectionId: isSet(object.paragonConnectionId)
        ? globalThis.String(object.paragonConnectionId)
        : isSet(object.paragon_connection_id)
        ? globalThis.String(object.paragon_connection_id)
        : "",
    };
  },

  toJSON(message: IntegrationDisconnect): unknown {
    const obj: any = {};
    if (message.provider !== "") {
      obj.provider = message.provider;
    }
    if (message.paragonConnectionId !== "") {
      obj.paragonConnectionId = message.paragonConnectionId;
    }
    return obj;
  },

  create(base?: DeepPartial<IntegrationDisconnect>): IntegrationDisconnect {
    return IntegrationDisconnect.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<IntegrationDisconnect>): IntegrationDisconnect {
    const message = createBaseIntegrationDisconnect();
    message.provider = object.provider ?? "";
    message.paragonConnectionId = object.paragonConnectionId ?? "";
    return message;
  },
};

function createBaseMCPConfigUpdate(): MCPConfigUpdate {
  return { config: undefined };
}

export const MCPConfigUpdate: MessageFns<MCPConfigUpdate> = {
  encode(message: MCPConfigUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.config !== undefined) {
      MCPConfiguration.encode(message.config, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MCPConfigUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMCPConfigUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.config = MCPConfiguration.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MCPConfigUpdate {
    return { config: isSet(object.config) ? MCPConfiguration.fromJSON(object.config) : undefined };
  },

  toJSON(message: MCPConfigUpdate): unknown {
    const obj: any = {};
    if (message.config !== undefined) {
      obj.config = MCPConfiguration.toJSON(message.config);
    }
    return obj;
  },

  create(base?: DeepPartial<MCPConfigUpdate>): MCPConfigUpdate {
    return MCPConfigUpdate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MCPConfigUpdate>): MCPConfigUpdate {
    const message = createBaseMCPConfigUpdate();
    message.config = (object.config !== undefined && object.config !== null)
      ? MCPConfiguration.fromPartial(object.config)
      : undefined;
    return message;
  },
};

function createBaseMCPServerUpsert(): MCPServerUpsert {
  return { server: undefined };
}

export const MCPServerUpsert: MessageFns<MCPServerUpsert> = {
  encode(message: MCPServerUpsert, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.server !== undefined) {
      MCPServer.encode(message.server, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MCPServerUpsert {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMCPServerUpsert();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.server = MCPServer.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MCPServerUpsert {
    return { server: isSet(object.server) ? MCPServer.fromJSON(object.server) : undefined };
  },

  toJSON(message: MCPServerUpsert): unknown {
    const obj: any = {};
    if (message.server !== undefined) {
      obj.server = MCPServer.toJSON(message.server);
    }
    return obj;
  },

  create(base?: DeepPartial<MCPServerUpsert>): MCPServerUpsert {
    return MCPServerUpsert.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MCPServerUpsert>): MCPServerUpsert {
    const message = createBaseMCPServerUpsert();
    message.server = (object.server !== undefined && object.server !== null)
      ? MCPServer.fromPartial(object.server)
      : undefined;
    return message;
  },
};

function createBaseMCPServerDelete(): MCPServerDelete {
  return { id: "" };
}

export const MCPServerDelete: MessageFns<MCPServerDelete> = {
  encode(message: MCPServerDelete, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MCPServerDelete {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMCPServerDelete();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MCPServerDelete {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: MCPServerDelete): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create(base?: DeepPartial<MCPServerDelete>): MCPServerDelete {
    return MCPServerDelete.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MCPServerDelete>): MCPServerDelete {
    const message = createBaseMCPServerDelete();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseMCPProfileUpsert(): MCPProfileUpsert {
  return { profile: undefined };
}

export const MCPProfileUpsert: MessageFns<MCPProfileUpsert> = {
  encode(message: MCPProfileUpsert, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.profile !== undefined) {
      MCPProfile.encode(message.profile, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MCPProfileUpsert {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMCPProfileUpsert();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.profile = MCPProfile.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MCPProfileUpsert {
    return { profile: isSet(object.profile) ? MCPProfile.fromJSON(object.profile) : undefined };
  },

  toJSON(message: MCPProfileUpsert): unknown {
    const obj: any = {};
    if (message.profile !== undefined) {
      obj.profile = MCPProfile.toJSON(message.profile);
    }
    return obj;
  },

  create(base?: DeepPartial<MCPProfileUpsert>): MCPProfileUpsert {
    return MCPProfileUpsert.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MCPProfileUpsert>): MCPProfileUpsert {
    const message = createBaseMCPProfileUpsert();
    message.profile = (object.profile !== undefined && object.profile !== null)
      ? MCPProfile.fromPartial(object.profile)
      : undefined;
    return message;
  },
};

function createBaseMCPProfileDelete(): MCPProfileDelete {
  return { providerId: "" };
}

export const MCPProfileDelete: MessageFns<MCPProfileDelete> = {
  encode(message: MCPProfileDelete, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.providerId !== "") {
      writer.uint32(10).string(message.providerId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MCPProfileDelete {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMCPProfileDelete();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.providerId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MCPProfileDelete {
    return {
      providerId: isSet(object.providerId)
        ? globalThis.String(object.providerId)
        : isSet(object.provider_id)
        ? globalThis.String(object.provider_id)
        : "",
    };
  },

  toJSON(message: MCPProfileDelete): unknown {
    const obj: any = {};
    if (message.providerId !== "") {
      obj.providerId = message.providerId;
    }
    return obj;
  },

  create(base?: DeepPartial<MCPProfileDelete>): MCPProfileDelete {
    return MCPProfileDelete.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MCPProfileDelete>): MCPProfileDelete {
    const message = createBaseMCPProfileDelete();
    message.providerId = object.providerId ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = numberToLong(Math.trunc(date.getTime() / 1_000));
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds.toNumber() || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function numberToLong(number: number) {
  return Long.fromNumber(number);
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
